import { AppState } from "@Store/index";
import { shallowEqual, useSelector } from "react-redux";

const useIsDesktop = () => {
  const { isDesktop } = useSelector(
    ({ appData }: AppState) => ({
      isDesktop: appData.isDesktop,
    }),
    shallowEqual,
  );
  return isDesktop;
};

export default useIsDesktop;
